<template>

  <div class="user">


    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
       

        <el-form-item label="">
          <el-input v-model="formInline.buser_search" placeholder="请输入购买人昵称"></el-input>
        </el-form-item>

        <el-form-item label="是否结算">
          <el-select placeholder="是否结算" v-model="formInline.is_settled">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
        </el-form-item>



        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="user_achievement_cnum_id" label="ID" > </el-table-column>
            <el-table-column prop="user.nickName" label="分佣对象" > </el-table-column>    
            <el-table-column prop="order_num" label="达成单数" > </el-table-column>
        
            <el-table-column prop="ratio_price" label="返佣金额" > </el-table-column>
            <el-table-column prop="is_settled" label="是否结算" >
                <template slot-scope="scope">
                    <div v-if="scope.row.is_settled == 0">未结算</div>
                    <div v-if="scope.row.is_settled == 1">已结算</div>
                </template>
            </el-table-column>
            <el-table-column prop="settled_time" label="结算时间" > </el-table-column>

            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>

            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/plus/uac/index/record'">购买记录</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <Edit :open_edit="open_edit" :user_achievement_cnum_id="user_achievement_cnum_id"  v-if="open_edit"   @close="closeEdit"></Edit>
  </div>
</template>

<script>
import uacApi from '@/api/uac.js';
import Edit from './record.vue';
export default {
  components: {
    Edit
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*当前编辑的对象*/
      userModel: {},
      formInline: {
        buser_search:"",
        order_search:"",
        user_search:"",
        is_settled:-1,
      },
      open_edit:false,


    };
  },
  created() {

    /*获取列表*/
    this.getTableList();
  },
  methods: {
    closeEdit(e){
      this.open_edit=false;
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    editClick(e){
      this.user_achievement_cnum_id = e.user_achievement_cnum_id;
      this.open_edit = true;
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      console.log("------")
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;

      uacApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },



  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/uac/index/index.vue